import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { FiltersBase, Formato, RelazioneAtlante } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<RelazioneAtlante>()

export function TableRelazioniAtlante({
  relazioni,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  relazioni: RelazioneAtlante[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {

  const numPages = useMemo(() => {
    if (!relazioni) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [relazioni, count])

  return (
    <Table
      data={relazioni}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(relazione) => (
          <Link to={`/atlanti/relazioni/${relazione.id}`}>
            <LinkMagik className="text-dark">{relazione.nome}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />
      <Table.Column
        title="Canonica"
        width="minmax(max-content, 1fr)"
        sortable
        name="canonica"
        render={(relazione) => (relazione.canonica ? "Si" : "No")}
      />
      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} relazioni atlante.
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>

    </Table>
  )
}
